import { GuruSlider, GuruSlide } from '../../../../components'
import React from 'react'
import BrandIcon from '../../../../components/brand-icon/BrandIcon'
import { REACT_APP_BFF_IMAGE } from '../../../../config'
import { useHistory } from 'react-router-dom'
import './index.scss'

interface Brand {
  _id: string
  name: string
  logo: string
}

const brands: Brand[] = [
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },

  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
  {
    _id: '5f3db71a3e58d50023de026d',
    name: 'Bonanza',
    logo: 'bonanza_1626973907329.png',
  },
]

function BrandsHomeFulfillment() {
  const history = useHistory()

  return (
    <div className="brands-home-fulfillment">
      <div className="slides">
        <GuruSlider 
          pager={false} 
          scrollbar={false} 
          autoHeight={true}
          slidesPerView='auto'
        >
          {brands.map((brand, index) => (
            <GuruSlide key={index} className="slide-home-brand">
              <BrandIcon urlLogo={`${REACT_APP_BFF_IMAGE}brands/${brand.logo}`} handleAction={() => {}} />
            </GuruSlide>
          ))}
        </GuruSlider>
      </div>

      <span className="all-brands" onClick={() => history.push('/brands-fulfillment')}>
        Todas las marcas
      </span>
    </div>
  )
}

export default BrandsHomeFulfillment
